import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { FlexRow } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { StPageLinkContainer } from './PageLink.styled'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { To } from 'react-router-dom'

type PageLinkProps = {
  icon: IconProp
  children: string
  color?: string
  renderRaw?: boolean
  to?: To
  external?: boolean
  onClick?: () => void
}

const PageLink = ({ children, renderRaw, color, icon, to, external, onClick }: PageLinkProps) => {
  const theme = useTheme()

  // Render Methods
  // ------------------------------------------------------------------------- /
  function renderContents() {
    return (
      <FlexRow alignItems='center' justifyContent='space-between'>
        <Span type='BodyMediumRegular' color={color || theme.Colors.Neutrals.Darkest}>
          {children}
        </Span>

        <FontAwesomeIcon icon={icon} color={color || theme.Colors.Neutrals.Darkest} />
      </FlexRow>
    )
  }

  function renderAsLink(to: To) {
    return external ? (
      <a href={to as string} target='_blank' rel='noreferrer'>
        {renderContents()}
      </a>
    ) : (
      <Link to={to}>{renderContents()}</Link>
    )
  }

  function renderAsPressable() {
    return (
      <button type='button' onClick={onClick}>
        {renderContents()}
      </button>
    )
  }

  return (
    <StPageLinkContainer>
      {to ? renderAsLink(to) : renderRaw ? renderContents() : renderAsPressable()}
    </StPageLinkContainer>
  )
}

export { PageLink }
